import { createContext } from 'react'

export interface IMCsContext {
  searchQuery: string
  setSearchQuery(value: string): void
}

export const MCsContext = createContext<IMCsContext>({
  searchQuery: '',
  setSearchQuery: () => {},
})
